import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../app/api/apiSlice";

// Create the images entity adapter
const imagesAdapter = createEntityAdapter({
  selectId: (image) => image.id,  // Specify that 'id' is the unique identifier
});

const initialState = imagesAdapter.getInitialState();

export const imagesApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getImages: builder.query({
      query: () => ({
        url: '/images',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      // No need to transform the `id` here since it's already available
      transformResponse: (responseData) => {
        // Return normalized data using the entity adapter
        return imagesAdapter.setAll(initialState, responseData);
      },
    }),
  }),
});

export const {
  useGetImagesQuery
} = imagesApiSlice;
